/** Default when user has not set a timezone. */
export const DEFAULT_USER_TIMEZONE = 'UTC';

const STORAGE_KEY = 'srTimezone';

/**
 * @param {string|null|undefined} tz
 * @returns {boolean}
 */
export function isValidIanaTimezone(tz) {
  if (!tz || typeof tz !== 'string') return false;
  try {
    Intl.DateTimeFormat(undefined, { timeZone: tz });
    return true;
  } catch {
    return false;
  }
}

/**
 * @param {string|null|undefined} tz
 * @returns {string}
 */
export function normalizeUserTimezone(tz) {
  const candidate = String(tz || '').trim();
  if (isValidIanaTimezone(candidate)) return candidate;
  return DEFAULT_USER_TIMEZONE;
}

/**
 * Read persisted user timezone (localStorage).
 * @returns {string}
 */
export function getUserTimezone() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return normalizeUserTimezone(stored);
  } catch {
    /* ignore */
  }
  return DEFAULT_USER_TIMEZONE;
}

/**
 * Persist timezone for formatters and app reload.
 * @param {string|null|undefined} tz
 */
export function persistUserTimezone(tz) {
  const normalized = normalizeUserTimezone(tz);
  try {
    localStorage.setItem(STORAGE_KEY, normalized);
  } catch {
    /* ignore */
  }
  return normalized;
}

/**
 * Clear on logout.
 */
export function clearUserTimezone() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
